import * as React from "react";
import SectionNumber from "../global/SectionNumber";
import SmartColour from "../../utils/ColourHandler";
import SmartText from "../../utils/TextHandler";
import SmartStyles from "../../utils/StyleHandler";

/********************************
<Intro />
/********************************
Version: 1
Created: 22 01 2025
Updated: 19 02 2025
Author: Richy Pears
/********************************
Displays intro copy
/********************************/

const Intro = ({ blok }) => {
  if (!blok) return null; // Escape hatch
  const { copy, ctas, number, padding, rounded, subtitle, theme, title } = blok;

  const colour = SmartColour(theme);

  return (
    <section
      className={`flex flex-col ${
        colour.classes && colour.classes
      } ${SmartStyles("padding", padding)} ${SmartStyles("rounded", rounded)}`}
    >
      <div className="brand-container flex flex-col gap-10 md:gap-12">
        <SectionNumber title={subtitle && subtitle} number={number && number} />
        {copy?.content[0]?.content && (
          <SmartText className="m-0 text-center brand-remove-last-margin">
            {copy}
          </SmartText>
        )}
      </div>
    </section>
  );
};

export default Intro;
